import { Injectable, Injector, PLATFORM_ID } from '@angular/core';
import * as Sentry from '@sentry/angular';
import {
    SENTRY_DSN,
    SENTRY_ENVIRONMENT,
    SentryConfigService
} from "../sentry-config/sentry-config.service";
import { environment } from "../../../environments/environment";
import type { Client } from '@sentry/core';

@Injectable({
  providedIn: 'root'
})
export class SentryService {
  instance?: Client;
  private injector: Injector;

  constructor() {
    this.injector = Injector.create({
      providers: [
        { provide: PLATFORM_ID, useValue: 'browser' },
        { provide: SENTRY_DSN, useValue: 'https://84a28e198c030289db2f746ea9f4b3a4@o4510040818909184.ingest.de.sentry.io/4510040841584720' },
        { provide: SENTRY_ENVIRONMENT, useValue: environment.name },
        {
          provide: SentryConfigService,
          useFactory: () => {
            return new SentryConfigService(
              this.injector.get(SENTRY_DSN),
              this.injector.get(SENTRY_ENVIRONMENT)
            );
          }
        }
      ]
    });
  }

  init() {
    const sentryConfigService = this.injector.get(SentryConfigService);
    this.instance = Sentry.init({ ...sentryConfigService });
  }
}
